// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"19":"blog","40":"debug","75":"mc","472":"settings","792":"main"}[chunkId] + "-" + {"19":"93c66","40":"6aec6","75":"15653","472":"0c350","792":"95359"}[chunkId] + ".js";
};